module.exports = __webpack_public_path__ + "img/banner2.2e463cc5.png";